import { Button } from "@mui/material";

export const CustomButton = ({
  text,
  onClick,
  size = "medium",
  fullWidth = false,
  disabled = false,
  color = "primary.brandMain",
  backgroundColor = "primary.main",
  borderColor = "transparent",
  disabledColor,
  disabledBackgroundColor,
  borderRadius,
  textTransform = "none",
  icon = null,
  iconPosition = "left",
  sx: sxProp = {},
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={iconPosition === "left" ? icon : null}
      endIcon={iconPosition === "right" ? icon : null}
      {...props}
      sx={{
        color,
        backgroundColor,
        borderRadius: "8px",
        textTransform,
        fontSize: "14px",
        p: 1,
        "& .MuiButton-startIcon": {
          marginRight: iconPosition === "left" ? 3 : 0,
        },
        "& .MuiButton-endIcon": {
          marginLeft: iconPosition === "right" ? 3 : 0,
        },
        "&:disabled": {
          backgroundColor: disabledBackgroundColor || "primary.main40",
          color: disabledColor || "primary.white",
          cursor: "not-allowed",
          pointerEvents: "none",
        },
        transition: "all 0.3s ease",
        ...sxProp,
      }}
    >
      {text}
    </Button>
  );
};
